import { links } from "@octopusdeploy/portal-routes";
import React from "react";
import { repository } from "~/clientInstance";
import DataBaseComponent from "~/components/DataBaseComponent/index";
import InternalRedirect from "~/components/Navigation/InternalRedirect/InternalRedirect";
import { SkeletonLoadingLayout } from "~/components/SkeletonLoadingLayout/SkeletonLoadingLayout";
export interface LicenseGuardProps {
    spaceId: string;
    children: JSX.Element;
}
interface State {
    licenseChecked: boolean;
    hasInsightsLicenseFeature: boolean;
}
class LicenseChecker extends DataBaseComponent<LicenseGuardProps, State> {
    constructor(props: LicenseGuardProps) {
        super(props);
        this.state = {
            licenseChecked: false,
            hasInsightsLicenseFeature: false,
        };
    }
    async componentDidMount() {
        await this.doBusyTask(async () => {
            const licenseCheck = await repository.InsightsReports.getInsightsLicenseCheck();
            this.setState({ licenseChecked: true, hasInsightsLicenseFeature: licenseCheck.HasInsightsLicenseFeature });
        });
    }
    render() {
        const { hasInsightsLicenseFeature } = this.state;
        if (this.state.busy || !this.state.licenseChecked)
            return <SkeletonLoadingLayout errors={this.errors}/>;
        if (hasInsightsLicenseFeature)
            return this.props.children;
        return <InternalRedirect to={links.insightsReportUpsellPage.generateUrl({ spaceId: this.props.spaceId })}/>;
    }
    static displayName = "LicenseChecker";
}
export default LicenseChecker;
